import { useEffect, useState } from "react";
import { ChildrenProp } from "../../types/common";
import { UserAgentContext, UserDevice } from "./UserAgentContext";

const TABLET_MIN_WIDTH = 768;

/**
 * 장치 판별 기준:
 * - DESKTOP : UA에 "Windows NT" 포함 (Windows PC 전용 앱)
 * - TABLET  : UA에 "iPad" 포함, 또는 Android + 화면 폭 768px 이상
 * - MOBILE  : 그 외 모든 기기 (iPhone, 소형 Android 등)
 */
function detectDevice(): UserDevice {
  const ua = navigator.userAgent;
  const innerWidth = window.innerWidth;

  // Windows PC
  if (/Windows NT/i.test(ua)) return UserDevice.DESKTOP;

  // iPad (iPadOS 13+ 이후 일부 모델은 UA가 Macintosh처럼 보이므로 maxTouchPoints 병행 체크)
  if (/iPad/i.test(ua)) return UserDevice.TABLET;
  if (/Macintosh/i.test(ua) && navigator.maxTouchPoints > 1) return UserDevice.TABLET;

  // Android 태블릿 (화면 폭 768px 이상)
  if (/Android/i.test(ua) && innerWidth >= TABLET_MIN_WIDTH) return UserDevice.TABLET;

  // 그 외: iPhone, 소형 Android 등 → MOBILE
  return UserDevice.MOBILE;
}

export function UserAgentProvider({ children }: ChildrenProp) {
  const [device, setDevice] = useState<UserDevice>(() => detectDevice());

  const updateDeviceType = () => {
    const next = detectDevice();
    if (next !== device) setDevice(next);
  };

  useEffect(() => {
    window.addEventListener("resize", updateDeviceType);
    return () => window.removeEventListener("resize", updateDeviceType);
    // eslint-disable-next-line
  }, [device]);

  const isDesktop = device === UserDevice.DESKTOP;
  const isTablet = device === UserDevice.TABLET;
  const isMobile = device === UserDevice.MOBILE;

  return (
    <UserAgentContext.Provider value={{ isDesktop, isTablet, isMobile, device }}>{children}</UserAgentContext.Provider>
  );
}

